import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

import usersModule from './users';
import jobsModule from './jobs';
import tasksModule from './tasks';
import bubblesModule from './bubbles';
import reportsModule from './reports';
import utilitiesModule from './utilities';
import questionsModule from './questions';
import isoModule from './iso';
import loadingModule from './loading';
import websocketModule from './websocket';
import documentsModule from './documents';
import diagramModule from './diagram';
import repairSelectModule from './repairselect';
import offlineModule from './offline';
import conflictsModule from './conflicts';
import chatModule from './chat';
import instrumentationsModule from './instrumentations';
import notificationsModule from './notifications';
import permissionsModule from './permissions/index';
import jobPhasesModule from './jobPhases';
import client from '../config/api';
import workInstruction from './workInstruction';
import standardTasksModule from './standardTasks';
import changeLogModule from './changeLog';

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules: {
    UsersModule: usersModule,
    JobsModule: jobsModule,
    ReportsModule: reportsModule,
    UtilitiesModule: utilitiesModule,
    TasksModule: tasksModule,
    BubblesModule: bubblesModule,
    QuestionsModule: questionsModule,
    IsoModule: isoModule,
    LoadingModule: loadingModule,
    WebsocketModule: websocketModule,
    DocumentsModule: documentsModule,
    DiagramModule: diagramModule,
    RepairSelect: repairSelectModule,
    OfflineModule: offlineModule,
    ConflictsModule: conflictsModule,
    ChatModule: chatModule,
    InstrumentationsModule: instrumentationsModule,
    NotificationsModule: notificationsModule,
    PermissionsModule: permissionsModule,
    WorkInstructionModule: workInstruction,
    JobPhasesModule: jobPhasesModule,
    StandardTasksModule: standardTasksModule,
    ChangeLogModule: changeLogModule,
  },
});

client.injectStore(store);

export default store;
